import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';
import { refreshOrder } from 'apollo/order-live-updates';

/**
 * Re-reads every view of an order that is on screen: the details page and any list row
 * (DD-3231). It is the same refresh an ORDER_CHANGED socket event runs, so a mutation whose
 * result Apollo cannot normalize into the Order (it returns another type, or goes over
 * REST) calls this instead of patching the order by hand. A mutation that returns the
 * Order with its _id needs nothing: Apollo writes it into the cache itself.
 */
export const useRefreshOrder = () => {
    const client = useApolloClient();
    return useCallback((orderId: string) => refreshOrder(client, orderId), [client]);
};
